import Vue from 'vue'
import Vuex from 'vuex'
import ConfigurationAuthStore from './modules/ConfigurationAuthStore'
import ConfigurationStore from './modules/ConfigurationStore'
import ContextStore from './modules/ContextStore'
import UserDataStore from './modules/UserDataStore'
import NotificationStore from './modules/NotificationStore'
import UserActivityStore from './modules/UserActivityStore'
import LoaderStore from './modules/LoaderStore'
import TourStore from './modules/TourStore'
import MobileDataTableStore from './modules/mobileDataTableStore'
import ThemeStore from '@/store/modules/ThemeStore'

Vue.use(Vuex)

const state = {}
const mutations = {}
const actions = {}
const modules = {
  contextStore: ContextStore,
  configurationAuthStore: ConfigurationAuthStore,
  configurationStore: ConfigurationStore,
  userDataStore: UserDataStore,
  notificationStore: NotificationStore,
  userActivityStore: UserActivityStore,
  loaderStore: LoaderStore,
  tourStore: TourStore,
  mobileDataTableStore: MobileDataTableStore,
  themeStore: ThemeStore
}

export { state, mutations, actions, modules }

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules
})
